import {
  Button,
  CheckboxChangeEvent,
  Checkbox,
  Divider,
  Modal,
  Typography,
} from "antd";
import React from "react";
import dayjs from "dayjs";
import { useLoader } from "../../Context/LoaderContext/LoaderContext";
import { CloseOutlined } from "@ant-design/icons";

interface SlotPickerModalProps {
  selectedDate: dayjs.Dayjs;
  handleSlotPickerModalClose: () => void;
  handleBookSlot: () => void;
  selectedSlot: any;
  slots: any[];
  handleSlotChange: (slot: any) => void;
}

const SlotPickerModal: React.FC<SlotPickerModalProps> = ({
  selectedDate,
  handleSlotPickerModalClose,
  handleBookSlot,
  selectedSlot,
  slots,
  handleSlotChange,
}) => {
  const { isLoading } = useLoader();

  const modalTitle = `Slots for ${dayjs(selectedDate)
    .format("D MMM YYYY")
    .toUpperCase()}`;

  const filetredSlots = slots.filter((slot: any) =>
    dayjs(slot.start).isSame(selectedDate, "day")
  );

  return (
    <Modal
      closeIcon={null}
      open={!!selectedDate}
      maskClosable={!isLoading}
      keyboard={false}
      centered
      cancelButtonProps={{
        style: {
          display: "none",
        },
      }}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
      onCancel={handleSlotPickerModalClose}
      width={"100%"}
      style={{ maxWidth: "800px" }}
    >
      <section className="slot-picker-modal-container">
        <div className="slot-picker-modal-header">
          <Typography.Title level={5} style={{ margin: 0 }}>
            {modalTitle} <br />
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {filetredSlots.length} slots available
            </Typography.Text>
          </Typography.Title>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={handleSlotPickerModalClose}
          />
        </div>
        <Divider style={{ margin: 0 }} />

        <div className="slots-grid">
          {filetredSlots.map((slot: any, index: number) => (
            <div
              className={`slot-card ${
                selectedSlot === slot ? "selected-slot" : ""
              }`}
              key={index}
              onClick={() => handleSlotChange(slot)}
            >
              <Typography.Text>
                {dayjs(slot.start).format("hh:mm A")} &nbsp; to &nbsp;
                {dayjs(slot.end).format("hh:mm A")}
              </Typography.Text>
              <Checkbox
                key={index}
                checked={selectedSlot === slot}
                onChange={(e: CheckboxChangeEvent) => {
                  e.stopPropagation();
                  handleSlotChange(slot);
                }}
              />
            </div>
          ))}
        </div>

        <Divider style={{ margin: 0 }} />

        <div className="slot-picker-modal-footer">
          <Button
            type="default"
            onClick={handleSlotPickerModalClose}
            disabled={isLoading}
            loading={isLoading}
          >
            Close
          </Button>
          <Button
            type="primary"
            onClick={handleBookSlot}
            disabled={!selectedSlot || isLoading}
            loading={isLoading}
          >
            Schedule Interview
          </Button>
        </div>
      </section>
    </Modal>
  );
};

export default SlotPickerModal;
